import React from 'react';
import styled from 'styled-components'

export default function VentBlock({ title, count, two, three, four }) {
  return (<>
    <CBox>
      <Header>
        <HL>{title}</HL>
        <HR>{count}</HR>
      </Header>
      <Mid>
        {two}
      </Mid>
      <Bottom>
        <BL>{three}</BL>
        <BR>{four}</BR>
      </Bottom>
    </CBox>
  </>)
}

const Mid = styled.div`
font-size: 14px;
color: rgba(255,255,255,0.5);
display: flex;
height: 100%;
flex-direction: row;
align-items: flex-end;

`;
const BL = styled.div``;
const BR = styled.div``;

const Bottom = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: rgba(255,255,255,0.5);
`;

const HL = styled.div``;
const HR = styled.div`
  font-size: 50px;
  line-height: 50px;
        @media screen and (max-width: 823px) and (orientation: landscape) {
      font-size: 20px;
      line-height: 20px;
    }
`;
export const Box = styled.div`
  background-color: rgba(255,255,255,0.1);
  color: white;
  border-radius: 10px;
  padding: 20px;
          @media screen and (max-width: 823px) and (orientation: landscape) {
      padding: 5px 10px;
      overflow: hidden;
    }
`;

const CBox = styled(Box)`
    display: grid;
    grid-template-rows: auto 1fr auto;
            @media screen and (max-width: 823px) and (orientation: landscape) {
      font-size: 13px;
    }
`;

const Header = styled.div`
display: flex;
flex-flow: row nowrap;
justify-content: space-between;
  font-weight: 600;
`;
